import React from 'react';
import CommunityImg from '../../Common/CommunityImg/CommunityImg';
import { default as challenge1 } from '../../../images/creative_challenge_1.svg';
import { default as challenge2 } from '../../../images/creative_challenge_2.svg';
import { default as noIssueChallengeImg2 } from '../../../images/Creative_community_noissueChallenge_badge.svg';
import './CreativeChallenge.scss';

const CreativeChallenge = ({
  onCreativeChallengeList,
  onBackToCommunity,
  isInstaList
}) => {

  const openLink = (url) => window.open(url, '_blank', 'noopener');

  return (
    <div className={`creative-challenge-container without-noissue-challenge ${isInstaList ? 'insta-list' : ''}`}>
      <div className="creative-challenge-header">
        <CommunityImg className="image1" src={challenge1} alt="challenge 1" />
        <div className="content">
          {
            isInstaList && 
            <div 
              className="creative-community-return-link"
              onClick={onBackToCommunity}
            > 
              Back to Creative Community 
            </div>
          }
          <div className="heading">The #noissuechallenge</div>
          <div className="sub-heading">
            Every month, we challenge our Creatives to submit a unique packaging design in line with a determined theme. Winners land a feature on the noissue homepage AND the chance to sell their design on the noissue site!
            <br /><br />
            {isInstaList &&  `Vote for your favorite, and land them a feature on the noissue homepage!`}
          </div>
          {/* {
            !isInstaList && 
            <div className="creative-challenge-entry-button">
              <button onClick={()=>openLink('https://www.instagram.com/explore/tags/noissuechallenge')}>  See All Entries </button>
            </div>
          } */}
        </div>
        <CommunityImg className="image2" src={challenge2} alt="challenge 2" />
      </div>
      <div className="creative-no-issue-challenge">
        <div className="left-section">
          <div className="left-section-image">
            {/* <CommunityImg src={noIssueChallengeImg} alt="no issue challenge" /> */}
          </div>
          <div className="content">
            <div className="description">Meet the most recently crowned challenge champ and their winning design.</div>
            <button onClick={()=>openLink('https://www.instagram.com/p/CRiqdSaBxsq/')}>Check it Out</button>
          </div>
        </div>
        <div className="right-section">
          <CommunityImg className="noissue-badge" src={noIssueChallengeImg2} alt="no issue challenge badge" />
          <div className="description">
            <div className="title">
              Creatives, have you submitted your entry for this month's #noissuechallenge?
            </div>
            <button onClick={()=>openLink('https://www.instagram.com/p/CQ0T4Q1B9yp/')}>Join the Fun</button>
          </div>
          {/* <CommunityImg src={noIssueChallengeImg3} alt="no issue challenge badge" /> */}
        </div>
      </div>
    </div>
  )
}

export default CreativeChallenge;